import { cn } from '@/lib/utils';
import { PropsWithChildren } from 'react';

export interface InlineCodeProps {
  className?: string;
}

export function InlineCode({
  children,
  className,
}: PropsWithChildren<InlineCodeProps>) {
  return (
    <code
      className={cn(
        'bg-muted relative rounded-md px-[0.3rem] py-[0.2rem] font-mono text-[0.8rem] outline-none inline-block',
        className
      )}
    >
      {children}
    </code>
  );
}
